export const MAX_ATTACHMENT_SIZE_BYTES = 100 * 1024 * 1024; // 100 MB

export const SUPPORTED_ATTACHMENT_ACCEPT =
	'.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,image/jpeg,image/png,image/webp,image/gif,image/heic,video/mp4,video/quicktime,video/webm';
